<template>
  <div
    class="counter"
    :class="{ 'over-limit': overLimit }"
    v-html="
      lang.get('miscellaneous.counters.' + type, {
        used: counter,
        total: maximum
      })
    "
  ></div>
</template>

<script>
export default {
  inject: ['lang'],
  props: {
    type: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    maximum: {
      type: Number,
      required: true
    }
  },
  computed: {
    counter() {
      if (this.type === 'words') {
        return this.value
          .split(
            /&nbsp;|(^|\s+)[!'"#$%&()*+,\-./\\:;<=>?@[\]^_`{|}~«»\u2000-\u206F\u2E00-\u2E7F\s]+(\s+|$)|\s+/
          )
          .filter(value => value && value.trim()).length;
      } else {
        const value = this.value.trim().replace(/&nbsp;/g, ' ');
        return value.length ? value.match(/./g).length : 0;
      }
    },
    overLimit() {
      return this.counter > this.maximum;
    }
  }
};
</script>

<style>
.counter {
  float: none;
  text-align: right;
}
.over-limit {
  color: red;
}
</style>
